<button mat-icon-button [matTooltip]="matTooltip | translate">
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
</button>
<ng-template #buttonContent>
    <ng-content></ng-content>
</ng-template>